import { getLocalizedString } from "common/components/localization";
import type { BaseProps } from "./custom-sign-in-props";
import { Button, ButtonWrapper, ContentContainer, Input, Subtitle, Title } from "./custom-sign-in-style";

interface Props extends BaseProps {}

const NameInputImpl: React.FunctionComponent<Props> = p => {
    const { greeting, description, colorTheme, onPressedContinue, canContinue, username, onUsernameChange, appKind } =
        p;

    return (
        <>
            <ContentContainer>
                <div>
                    <Title data-test="app-sign-in-title">{greeting}</Title>
                    <Subtitle id="sign-in-description" data-test="app-sign-in-subtitle">
                        {description}
                    </Subtitle>
                    <Input
                        data-test="app-name-input"
                        value={username}
                        onChange={e => onUsernameChange(e.target.value)}
                        type="text"
                        inputMode="text"
                        placeholder={getLocalizedString("name", appKind)}
                        colorTheme={colorTheme}
                        autoFocus={true}
                    />
                </div>
            </ContentContainer>
            <ButtonWrapper colorTheme={colorTheme} showFooter={false}>
                <Button onClick={onPressedContinue} disabled={canContinue === false}>
                    {getLocalizedString("continue", appKind)}
                </Button>
            </ButtonWrapper>
        </>
    );
};

const NameInput = NameInputImpl;
export default NameInput;
